import { useEffect, useState } from 'react';
import { client as api } from '../services/api';
import { useSchedule } from '../context/ScheduleContext';
import { digitsOnly } from '../utils/documento';

const BUSCAR_PEDIDO_STORAGE_KEY = 'buscarPedidoPayload';

function documentFromSession(): string {
  const raw = sessionStorage.getItem(BUSCAR_PEDIDO_STORAGE_KEY);
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as { document?: string };
      if (parsed.document) return digitsOnly(parsed.document);
    } catch {
      /* ignore */
    }
  }
  const legacy = sessionStorage.getItem('searchedDocument');
  return legacy ? digitsOnly(legacy) : '';
}

export const useEcommerceOrder = (
  selectedOrderId: string | null,
  pedidoEcommerceFromList: string | undefined
) => {
  const { setData } = useSchedule();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!selectedOrderId) return;

    if (pedidoEcommerceFromList) {
      setData((prevState) => ({
        ...prevState,
        pedidoEcommerce: pedidoEcommerceFromList,
      }));
      return;
    }

    const document = documentFromSession();
    if (!document) return;

    const loadItem = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.post('/agendamento/buscaitem', {
          idGar: digitsOnly(selectedOrderId),
          document,
        });
        setData((prevState) => ({
          ...prevState,
          pedidoEcommerce: response.data?.pedidoEcommerce ?? '',
        }));
      } catch {
        setError('Erro ao buscar o pedido');
      } finally {
        setLoading(false);
      }
    };

    void loadItem();
  }, [selectedOrderId, pedidoEcommerceFromList, setData]);

  return { loading, error };
};
